import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Menu, MenuModule } from "primeng/menu";
import { MenuItemInterface } from "@kernel/tools/menu/interfaces/menu-item.interface";

@Component({
  selector: "sxw-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
  imports: [MenuModule],
})
export class MenuComponent implements OnInit {
  @Input() popup = false;
  @Input() items?: MenuItemInterface[];
  @Input() appendTo: any = "body";

  @ViewChild("menu") menu!: Menu;
  constructor() {}

  ngOnInit(): void {}

  toggle(event: any) {
    this.menu.toggle(event);
  }
}
